/*
The OneHub integrator page comes with a heading where the role "banner" is assigned.
This can be used to check if resp. heading is present.
<br/>
<b>Note</b>: 
If a block with role banner is included in the local integrator page this might lead to unintended behaviour.
 */
export const isMissingOneHubMenu = document.querySelectorAll('[role="banner"]').length === 0;
